import type { CityConfig } from "../city-template/types";

export const castlePinesConfig: CityConfig = {
  city: "Castle Pines",
  state: "Colorado",
  stateAbbr: "CO",
  slug: "castle-pines",
  route: "/cities/castle-pines",
  title: "Emergency & Expedited Passport Castle Pines CO | Same-Day Douglas County | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Castle Pines, Colorado — as fast as 24 hours. Same-day courier processing for Castle Pines, Castle Rock, Lone Tree, Highlands Ranch, and all Douglas County travelers. A+ BBB rated, registered State Dept. courier. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Castle Pines, CO",
  heroSubtitle: "International golf trip to Scotland and your passport is expired? Family vacation to Europe departing in a week? We help Castle Pines residents — from The Ridge homeowners to Castle Pines Village families to Douglas County professionals — get their passports quickly. As a registered U.S. Department of State courier, we offer a best price guarantee and rates typically 30–100% lower than other passport courier resellers. As fast as 24 hours. A+ BBB rated.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Castle%20Pines%20Colorado%20luxury%20suburban%20community%20with%20ponderosa%20pine%20forests%20and%20rolling%20hills%2C%20the%20iconic%20Castle%20Pines%20Golf%20Club%20with%20manicured%20fairways%20against%20the%20Rocky%20Mountain%20foothills%20backdrop%2C%20elegant%20residential%20neighborhoods%20with%20large%20homes%20nestled%20among%20mature%20pine%20trees%2C%20the%20Ridge%20at%20Castle%20Pines%20with%20its%20distinctive%20natural%20landscaping%2C%20warm%20golden%20Colorado%20afternoon%20light%20filtering%20through%20pine%20canopies%2C%20professional%20landscape%20photography%2C%20no%20visible%20text%20or%20people%2C%20wide%20cinematic%20view%20with%20rich%20green%20and%20gold%20tones&width=1800&height=700&seq=castlepines-hero-001&orientation=landscape",
  heroImageAlt: "Castle Pines Colorado with ponderosa pine forests and Rocky Mountain foothills",
  geoPosition: "39.4717;-104.8947",
  geoPlacename: "Castle Pines, Colorado",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Denver Passport Agency",
    address: "3151 S. Vaughn Way, Aurora, CO 80014",
    distance: "Approximately 30 miles north via I-25 and C-470 — about 35–40 minutes",
  },
  nearbyCitiesZips: [
    { name: "Castle Pines", zips: "80108" },
    { name: "Castle Rock", zips: "80104, 80108, 80109" },
    { name: "Lone Tree", zips: "80124" },
    { name: "Highlands Ranch", zips: "80126, 80129, 80130" },
    { name: "Parker", zips: "80134, 80138" },
    { name: "Sedalia", zips: "80135" },
    { name: "Larkspur", zips: "80118" },
    { name: "Franktown", zips: "80116" },
    { name: "Greenwood Village", zips: "80111, 80121" },
    { name: "Centennial", zips: "80111, 80112, 80122" },
    { name: "Louviers", zips: "80131" },
    { name: "Perry Park", zips: "80118" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier service for urgent Castle Pines international departures via DEN" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved — skip the drive to Aurora" },
    { icon: "ri-flight-takeoff-line", title: "I-25 Corridor Access", desc: "Convenient I-25 access to Denver International Airport" },
    { icon: "ri-mail-send-line", title: "Overnight Shipping", desc: "Prepaid labels from UPS or FedEx in Castle Rock, Lone Tree, or Highlands Ranch" },
  ],
  internalLinks: [
    { name: "Expedited passport in Denver, CO", route: "/cities/denver" },
    { name: "Emergency passport help in Castle Rock, CO", route: "/cities/castle-rock" },
    { name: "Fast passport renewal in Castle Pines area", route: "/cities/castle-pines" },
    { name: "Urgent passport services for Lone Tree and Highlands Ranch", route: "/cities/highlands-ranch" },
    { name: "Colorado passport services overview", route: "/states/colorado" },
    { name: "Passport courier services in Parker and Centennial", route: "/cities/parker" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Castle Pines remotely via secure registered courier. Our couriers hand-deliver your documents directly to U.S. Department of State processing facilities. Castle Pines' prime location along the I-25 corridor — just 30 miles from the Denver Passport Agency — makes our courier service the ideal choice. Skip the drive through metro traffic and let us handle everything.",
  fpcOfficeAddress: "3151 S. Vaughn Way, Aurora, CO 80014",
  fpcOfficeDistance: "Serving all of Castle Pines, Castle Pines Village, The Ridge, and the I-25 south corridor",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Castle Pines and the surrounding Douglas County area. From The Ridge at Castle Pines to Castle Pines Village, from the neighborhoods along Happy Canyon Road to the communities near the Castle Pines Golf Club — we serve every corner of Castle Pines and the surrounding south metro communities.",
  nearbyCitiesIntro: "We serve Castle Pines and all nearby communities including Castle Rock, Lone Tree, Highlands Ranch, Parker, Sedalia, Larkspur, Franktown, and the southern I-25 corridor.",
  howItWorksIntro: "Most Castle Pines travelers complete everything online and ship documents via overnight courier. Our registered couriers handle the State Department delivery — you never need to drive north through the I-25 corridor to Aurora.",
  mistakesIntro: "Castle Pines is a premier Douglas County community with luxury homeowners, golf enthusiasts, and families. Here are the most common passport mistakes we see from Castle Pines-area travelers.",
  testimonialsIntro: "Castle Pines travelers — from golf trip planners to international vacationers to Douglas County families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Castle Pines, CO? Here are the most common ones we hear from Douglas County travelers.",
  statePageRoute: "/states/colorado",
  statePageName: "Colorado",
  dmvWebsite: "https://dmv.colorado.gov",
  dmvLabel: "Colorado DMV — Official Website",
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Colorado Vital Records (Birth, Death, Marriage)", href: "https://cdphe.colorado.gov/certificates-and-records" },
    { label: "Douglas County Clerk & Recorder", href: "https://www.douglas.co.us/clerk-recorder/" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to Aurora (35–40 minutes each way)", "I-25 corridor traffic northbound can be heavy"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "No Aurora drive required — ship from Castle Pines area", "Perfect for golf trips and European vacations", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service", "Good for planned seasonal travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Castle Pines travelers with immediate departure needs — as fast as 24 hours. Our couriers provide the fastest service available without driving the I-25 corridor to Aurora.",
      bullets: ["24–48 hour turnaround available", "DIA (DEN) departure support via I-25/C-470", "Golf trip and international vacation expertise"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Castle Pines adults with a passport issued within the last 15 years. Skip the post office and let our couriers handle everything.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Castle Pines address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Castle Pines residents and Douglas County families — including young adults and new homeowners.",
      bullets: ["Acceptance facility scheduling in Castle Rock or Lone Tree", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Castle Pines residents who lost their passport before international travel — business or vacation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Castle Pines and Douglas County families traveling internationally with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Castle Pines and Douglas County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Castle Pines CO", description: "Urgent passport processing for Castle Pines Colorado travelers with immediate departure needs from DEN." },
    { name: "Expedited Passport Renewal Castle Pines CO", description: "Fast passport renewal for Castle Pines Colorado residents with a previously-issued passport." },
    { name: "First-Time Passport Castle Pines CO", description: "New passport application services for Castle Pines Colorado residents applying for their first passport." },
    { name: "Child Passport Castle Pines CO", description: "Minor passport services for Castle Pines Colorado families with children under 16." },
  ],
  testimonials: [
    {
      name: "Richard T.",
      location: "Castle Pines, CO — The Ridge",
      rating: 5,
      text: "Golf trip to St. Andrews booked 6 months in advance and realized my passport expired 2 weeks before. Fast Passport Center got my renewal done in 4 days. Shipped from the UPS Store in Castle Rock. Absolutely saved a once-in-a-lifetime trip.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Susan M.",
      location: "Castle Pines, CO — Castle Pines Village",
      rating: 5,
      text: "Family trip to London and Paris. My husband's passport had water damage and needed replacement. Fast Passport Center handled it in 5 days. Incredible service for the Douglas County community.",
      service: "Emergency Passport Replacement",
    },
    {
      name: "Greg P.",
      location: "Castle Pines, CO — Happy Canyon",
      rating: 5,
      text: "Business conference in Tokyo on short notice. Needed a new passport in under a week. Fast Passport Center delivered in 4 days. No need to drive up I-25 to Denver — everything handled remotely.",
      service: "Emergency Passport",
    },
    {
      name: "Lauren D.",
      location: "Castle Rock, CO — Near Castle Pines border",
      rating: 5,
      text: "First-time passports for our two kids for a family reunion in Ireland. Fast Passport Center made the DS-11 process painless and got both passports in 6 days. Fantastic experience.",
      service: "Family Passport Bundle",
    },
  ],
  facilities: [
    {
      id: "cp-1",
      name: "Castle Rock Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "300 E Miller Ct",
      city: "Castle Rock",
      state: "CO",
      zip: "80104",
      phone: "(303) 688-2877",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Approximately 5 miles south of Castle Pines, in Castle Rock",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest and most accessible acceptance facility for Castle Pines residents. Convenient I-25 access. Good appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "cp-2",
      name: "Lone Tree Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10249 Park Meadows Dr",
      city: "Lone Tree",
      state: "CO",
      zip: "80124",
      phone: "(303) 790-0825",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Approximately 5 miles north of Castle Pines, in Lone Tree",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Northern acceptance facility for Castle Pines-Lone Tree corridor. Near Park Meadows Mall. Convenient for residents near the northern Castle Pines boundary.",
      icon: "ri-mail-line",
    },
    {
      id: "cp-3",
      name: "Highlands Ranch Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "9609 S University Blvd",
      city: "Highlands Ranch",
      state: "CO",
      zip: "80126",
      phone: "(303) 791-3080",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Approximately 8 miles northwest of Castle Pines, in Highlands Ranch",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Western acceptance facility for Castle Pines-Highlands Ranch corridor residents. Convenient C-470 access.",
      icon: "ri-mail-line",
    },
    {
      id: "cp-4",
      name: "Douglas County Clerk & Recorder — Castle Rock",
      type: "County Clerk Passport Acceptance",
      address: "301 Wilcox St",
      city: "Castle Rock",
      state: "CO",
      zip: "80104",
      phone: "(303) 660-7469",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Approximately 5 miles south of Castle Pines, in Castle Rock",
      website: "https://www.douglas.co.us/",
      websiteLabel: "Douglas County Clerk",
      notes: "County government passport acceptance in downtown Castle Rock. Extended hours including 8AM opening. Serves all Douglas County residents.",
      icon: "ri-government-line",
    },
    {
      id: "cp-5",
      name: "Parker Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "18695 Pony Express Dr",
      city: "Parker",
      state: "CO",
      zip: "80134",
      phone: "(303) 841-2771",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Approximately 8 miles east of Castle Pines, in Parker",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Eastern acceptance facility. Good alternative when Castle Rock and Lone Tree appointments are full. Serves the eastern Douglas County corridor.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 30-mile drive to Aurora via I-25/C-470", fpc: "No — ship from Castle Pines area" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "I-25 Northbound Traffic", agency: "Heavy during morning and evening rush", fpc: "No driving needed — courier handles it" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until Peak Travel Season",
      description: "Castle Pines families often wait until summer break or the holiday season to check passports. Routine processing takes 8–11 weeks. Start expedited service at least 4 weeks before travel — especially June through August and November through January.",
    },
    {
      icon: "ri-image-line",
      title: "Using Non-Compliant Passport Photos",
      description: "Castle Pines-area photo services may not stay current on the latest State Department requirements. Passport photos must be exactly 2×2 inches on a white background with no glasses, no shadows, and a neutral expression.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Taking Advantage of County Clerk Hours",
      description: "The Douglas County Clerk in Castle Rock opens at 8AM — an hour before post offices. Many Castle Pines residents don't realize this, opting for post office appointments with less convenient hours.",
    },
    {
      icon: "ri-car-line",
      title: "Underestimating I-25 Northbound Traffic",
      description: "Driving from Castle Pines to the Aurora passport agency means navigating I-25 north through the Denver Tech Center and C-470 — a route that can be heavily congested during rush hour. Our courier service eliminates this entirely.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking 6-Month Passport Validity",
      description: "Many European and Asian countries require 6 months of passport validity beyond your stay. Castle Pines golf travelers heading to Scotland or Ireland often discover this requirement at the last minute.",
    },
    {
      icon: "ri-golf-ball-line",
      title: "Assuming Travel Insurance Covers Passport Issues",
      description: "Travel insurance typically does not cover trip cancellation due to passport problems. Castle Pines travelers should verify passport status before booking non-refundable golf packages and international vacations.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Castle Pines or Douglas County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Castle Rock, Lone Tree, or Highlands Ranch." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for Douglas County documentation errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to State Department facilities — no I-25 northbound traffic battle." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Castle Pines address — trackable every step." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Castle Pines, CO?", a: "Fast Passport Center offers emergency passport processing in Castle Pines, Colorado in as little as 24–48 hours. Our registered couriers hand-deliver your documents to U.S. Department of State facilities — no need to drive 30 miles north via I-25 and C-470 to the Aurora passport agency." },
    { q: "Does Castle Pines have its own passport acceptance facility?", a: "No — Castle Pines does not have a dedicated acceptance facility. The nearest options are the Castle Rock Post Office (5 miles south), Lone Tree Post Office (5 miles north), or the Douglas County Clerk in Castle Rock (opens at 8AM for early appointments)." },
    { q: "What if I live in Castle Pines Village or The Ridge?", a: "Absolutely. Fast Passport Center serves all of Castle Pines including Castle Pines Village, The Ridge at Castle Pines, and the Happy Canyon Road corridor. Our service works the same way everywhere — ship your documents from any nearby UPS or FedEx location and we handle the rest." },
    { q: "Can you help with passports for golf travelers?", a: "Yes. Fast Passport Center serves Castle Pines' golf community — from Castle Pines Golf Club members heading to Scotland to recreational golfers traveling internationally. We understand the need for reliable, fast passport processing for once-in-a-lifetime golf trips." },
    { q: "How much does an expedited passport cost in Castle Pines, CO?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos near Castle Pines?", a: "Walgreens and King Soopers in Castle Rock offer passport photo services. UPS Store locations in Castle Rock and Lone Tree also provide photos. CVS in Highlands Ranch is another option. Photos must be 2×2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve the entire Castle Pines-Castle Rock corridor?", a: "Yes. Fast Passport Center serves the full I-25 south corridor including Castle Pines, Castle Rock, Lone Tree, Highlands Ranch, Sedalia, Larkspur, and all surrounding Douglas County communities." },
    { q: "How far is Castle Pines from Denver International Airport?", a: "Castle Pines is approximately 40 miles from Denver International Airport via I-25 and E-470 — about 40–45 minutes in normal traffic. Our courier service ensures your passport is ready before you need to make that drive." },
  ],
  photoLocations: [
    { name: "Walgreens — Castle Rock", address: "4340 Trail Boss Dr, Castle Rock, CO 80104", hours: "Mon–Sun: 8AM–9PM", website: "https://www.walgreens.com/storelocator" },
    { name: "King Soopers — Castle Rock", address: "100 Founders Pkwy, Castle Rock, CO 80104", hours: "Mon–Sun: 6AM–11PM", website: "https://www.kingsoopers.com/stores" },
    { name: "UPS Store — Lone Tree", address: "9227 E Lincoln Ave, Lone Tree, CO 80124", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–3PM", website: "https://locations.theupsstore.com/co/lone-tree" },
    { name: "CVS — Highlands Ranch", address: "9579 S University Blvd, Highlands Ranch, CO 80126", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator" },
  ],
  dmvLocations: [
    { name: "DMV — Castle Rock (Douglas County)", address: "301 Wilcox St, Castle Rock, CO 80104", hours: "Mon–Fri: 8AM–5PM", note: "Full-service DMV at the Douglas County Government offices in downtown Castle Rock. REAL ID and driver's license renewals. Approximately 5 miles south of Castle Pines.", featured: true },
    { name: "DMV — Lone Tree (Douglas County)", address: "9350 Heritage Hills Cir, Lone Tree, CO 80124", hours: "Mon–Fri: 8AM–5PM", note: "Alternative DMV in Lone Tree for northern Castle Pines residents. REAL ID processing available. Convenient C-470 access.", featured: false },
  ],
  airports: [
    {
      code: "DEN",
      name: "Denver International Airport",
      distance: "40 miles north via I-25 and E-470 — approximately 40–45 minutes",
      address: "8500 Peña Blvd, Denver, CO 80249",
      note: "Colorado's primary international airport with nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Accessible from Castle Pines via I-25 north and E-470.",
      flightUrl: "https://www.flydenver.com/",
      flightLabel: "DEN Flight Info",
      featured: true,
    },
    {
      code: "COS",
      name: "Colorado Springs Airport",
      distance: "45 miles south via I-25 — approximately 45–50 minutes",
      address: "7770 Milton E Proby Pkwy, Colorado Springs, CO 80916",
      note: "Regional airport serving Colorado Springs and southern Colorado. Limited domestic service to major hubs. No international flights. Alternative to DEN for southern Douglas County residents.",
      flightUrl: "https://www.flycos.com/",
      flightLabel: "COS Flight Info",
      featured: false,
    },
  ],
};